import React from "react";
import { useFormikContext } from "formik";
import TextInput from "../../../../../components/form/text-input";
import FancyRadioInput from "../../../../../components/form/fancy-radio-input";
import styles from "./style.module.scss";

const DualPricing = () => {
  const { values, errors, touched, handleBlur, handleChange } =
    useFormikContext();

  return (
    <div className={styles.container}>
      <h6>Select preferred dual pricing rate</h6>

      <div className={styles.pricing}>
        <FancyRadioInput
          id="dual_pricing_rate1"
          name="dual_pricing_rate"
          label="3%"
          value={3}
          onChange={handleChange}
          onBlur={handleBlur}
          checked={values.dual_pricing_rate == 3}
        />

        <FancyRadioInput
          id="dual_pricing_rate2"
          name="dual_pricing_rate"
          label="3.5%"
          value={3.5}
          onChange={handleChange}
          onBlur={handleBlur}
          checked={values.dual_pricing_rate == 3.5}
        />

        <FancyRadioInput
          id="dual_pricing_rate3"
          name="dual_pricing_rate"
          label="4%"
          value={4}
          onChange={handleChange}
          onBlur={handleBlur}
          checked={values.dual_pricing_rate == 4}
        />
      </div>

      <div className={styles.monthlyFee}>
        <TextInput
          label={"Monthly Fee"}
          type="text"
          prefix={"$"}
          suffix={"/mo"}
          placeholder={"0.00"}
          id={"dual_pricing_monthly_fee"}
          name={"dual_pricing_monthly_fee"}
          value={values?.dual_pricing_monthly_fee}
          onBlur={handleBlur}
          touched={touched?.dual_pricing_monthly_fee}
          errored={errors?.dual_pricing_monthly_fee}
          error={errors?.dual_pricing_monthly_fee}
          onChange={handleChange}
          cleaveOptions={{
            numeral: true,
            numeralDecimalScale: 2,
            numeralIntegerScale: 4,
            numeralPositiveOnly: true,
            onValueChanged: (e) => {
              handleChange({
                target: {
                  name: "dual_pricing_monthly_fee",
                  value: e.target.rawValue,
                },
              });
            },
          }}
        />
      </div>
    </div>
  );
};

export default DualPricing;
